<template>
	<div class="product-index pt-2">
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn color="primary" dark @click="openSearchDialog()"
					><v-icon>mdi-search</v-icon>注文データ検索</v-btn
				>
			</template>

			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters class="ma-2 d-flex" justify="end">
					<v-btn color="secondary" class="mb-2" @click="openSearchDialog()"
						><v-icon>mdi-search</v-icon>注文データ検索</v-btn
					>
				</v-row>
			</template>
			<template v-if="!$vuetify.breakpoint.xs">
				<v-row no-gutters class="ma-2 d-flex" justify="end">
					<v-btn
						v-if="authority_flag"
						color="primary"
						dark
						@click="$router.push({ name: 'order_data_new' })"
					>
						<v-icon class="mr-1">mdi-plus</v-icon>新規注文
					</v-btn>
				</v-row>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters class="ma-2 d-flex" justify="end">
					<v-btn
						v-if="authority_flag"
						color="secondary"
						dark
						@click="$router.push({ name: 'order_data_new' })"
					>
						<v-icon class="mr-1">mdi-plus</v-icon>新規注文
					</v-btn>
				</v-row>
			</template>

			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="order_data"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openShowDialog(item.id)">
							<td :class="{ 'blue--text': item.status_type === 'draft' }">
								{{ item.status_type_i18n }}
							</td>
							<td>
								{{ item.order_number }}
							</td>
							<td>
								{{ item.order_date | dateFormatter }}
							</td>
							<td>
								{{ item.supplier.name }}
							</td>
							<td>
								{{ item.supplier.pic_name }}
							</td>
							<td>
								{{ item.supplier.email }}
							</td>
							<td class="text-right">{{ item.total_price | formatPrice }}円</td>
							<td>
								{{
									item.order_data_components &&
									item.order_data_components.length > 0 &&
									item.order_data_components[0].order_component &&
									item.order_data_components[0].order_component.ordered_product
										? item.order_data_components[0].order_component.ordered_product.product_number
										: "対象製造番号なし"
								}}
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<OrderDataShowDialog :dialog.sync="dialog" :order_data_id="order_data_id" />
			<SearchOrderDataDialog
				:dialog.sync="searchDialog"
				:query="q"
				@search-orders="searchOrderData"
			/>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import SearchOrderedProduct from "./OrderComponentSearchPage.vue"
import OrderDataShowDialog from "./component/OrderDataShowDialog.vue"
import SearchOrderDataDialog from "./component/SearchOrderDataDialog.vue"
import PaginationModule from "../../modules/PaginationModule.vue"

import moment from "moment"
import "moment/locale/ja"

export default {
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY/MM/DD(dd)")
		},
		formatPrice(price) {
			return price.toLocaleString()
		},
	},
	components: {
		CommonFlame,
		FunctionTitle,
		SearchOrderedProduct,
		OrderDataShowDialog,
		SearchOrderDataDialog,
		PaginationModule,
	},
	data() {
		return {
			mainTitle: "",
			order_data_id: "",
			title: "外部発注一覧",
			common: common,
			selectedOrderedProduct: null,
			searchedOrderedProducts: [],
			orderedProductWildcardFlag: false,
			authority_flag: false,
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [
				{
					text: "注文状況",
					value: "status_type",
					width: "100px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "注文番号",
					value: "order_number",
					width: "150px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "注文日",
					value: "created_at",
					width: "150px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "注文先",
					value: "supplier_name",
					width: "150px",
					class: "px-1 font-size-075rem",
				},

				{
					text: "注文先担当者",
					value: "supplier_pic_name",
					width: "150px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "注文先メールアドレス",
					value: "supplier_email",
					width: "150px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "注文合計額",
					value: "total_quantity",
					width: "100px",
					class: "px-1 font-size-075rem",
				},
				{
					text: "対象製造番号",
					value: "product_number",
					width: "150px",
					class: "px-1 font-size-075rem",
				},
			],
			order_data: [],
			productOrderComponents: [],
			dialog: false,
			searchDialog: false,
			q: {
				sorts: "updated_at desc",
			},
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()

		this.fetchOrderData(this.q, page)
	},

	methods: {
		setQuery() {
			const query = this.$route.query
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					// this.q[query_key] = this.formatQuery(query[query_key])
					this.$set(this.q, query_key, this.formatQuery(query[query_key]))
				}
			})
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		totalPrice() {
			return this.order_data.reduce((total, order_data) => {
				return total + order_data.total_price
			}, 0)
		},

		openShowDialog(order_data_id) {
			this.order_data_id = order_data_id
			this.dialog = true
		},

		getPage(page) {
			this.fetchOrderData(this.q, page)
			this.$router.push({
				name: "order_data",
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		fetchOrderData(q, page) {
			const headers = authenticate.setHeader()
			const params = { page: page, q: q }

			axios
				.get("/erp/v1/order_data/order_data", {
					params,
					headers,
				})
				.then((res) => {
					this.order_data = res.data.order_data
					this.pagination = res.data.pagination
					this.authority_flag = res.data.authority_flag
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		resetOrderedProduct() {
			this.selectedOrderedProduct = null
			this.orderComponents = []
		},

		openSearchDialog() {
			this.searchDialog = true
		},
		searchOrderData(params) {
			this.q = params.q
			this.fetchOrderData(params.q, 1)
			this.$router.push({
				name: "order_data",
				query: params.q,
			})
			this.searchDialog = false
		},
	},
}
</script>
<style scoped lang="scss">
.text-blue {
	color: blue;
}
</style>
